<ion-header *ngIf="userIsAuthenticated">
    <ion-toolbar>
        <nav class="navbar navbar-light flex-menu-items">
            <button [class]="'menu-button' + (role == 'admin' ? ' admin' : '')" (click)="toggleMenu()">
                <img *ngIf="!isMenuOpen" src="assets/images/menu.svg" />
                <img *ngIf="isMenuOpen" src="assets/images/cross-circle.svg" />
            </button>
            <div class="logo-container">
                <img class="logo" src="assets/images/DMWhiteLogo-162x100.png" srcset="
                        assets/images/DMWhiteLogo-162x100.png 1x,
                        assets/images/DMWhiteLogo-324x200.png 2x,
                        assets/images/DMWhiteLogo-486x300.png 3x
                    " sizes="(max-width: 600px) 100px, 162px" alt="Digimaker Logo" />
            </div>
            <div class="menu-header-center" *ngIf="role && uiPermissions?.isAdminPanel">
                <div class="cursor backgroundColor">
                    <div class="header-font">
                        <h2 class="user-name">
                            {{ environment ? environment : '' }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="menu-header-center" *ngIf="role && !uiPermissions?.isAdminPanel && !utility.isInMobileView()">
                <div *ngIf="uiPermissions?.myCourseView" class="cursor" (click)="navigateMenu('student-course-lesson')">
                    <div class="header-font"
                        [class.active-menu]="router.url.includes('student-course-lesson')"
                        [class.inactive-menu]="!router.url.includes('student-course-lesson')">
                            My Courses
                    </div>

                </div>
                <div *ngIf="uiPermissions?.myProjectsView" class="cursor" (click)="navigateMenu('my-projects')">
                    <div class="header-font"
                        [class.active-menu]="router.url.includes('my-projects')"
                        [class.inactive-menu]="!router.url.includes('my-projects')">
                            My Projects
                </div>

                </div>
                <!-- Todo: Further remove hardcoded, i18 to get strings from JSON -->
                <div *ngIf="uiPermissions?.myChallengesView" class="cursor" (click)="navigateMenu('my-challenges')">
                    <div class="header-challenges"
                        [class.active-menu]="router.url.includes('my-challenges')"
                        [class.inactive-menu]="!router.url.includes('my-challenges')">
                           My Challenges
                        <span *ngIf="showNewBadge" class="challenge-badge">NEW</span>
                    </div>

                </div>
                <div class="cursor" (click)="navigateMenu('attendance-tutor')"
                    *ngIf="role && uiPermissions?.attendanceTutorView">
                    <div class="header-font"
     [class.active-menu]="router.url.includes('attendance-tutor')"
     [class.inactive-menu]="!router.url.includes('attendance-tutor')">
    Attendance
</div>

                </div>
            </div>
            <div class="right-container">
                <div class="end">
                    <div class="header-trophy" *ngIf="role=='student'">
                        <div class="header-trophy-row">
                            <!-- Loader -->
                            <ng-container *ngIf="!termScoreLoaded; else scoreBlock">
                                <ion-spinner name="dots" class="trophy-loader"></ion-spinner>
                            </ng-container>
                            <!-- Score -->
                            <ng-template #scoreBlock>
                                <ion-icon name="trophy-outline" class="trophy-icon"></ion-icon>
                                <span class="trophy-points">{{ term_score }}</span>
                            </ng-template>
                        </div>
                        <div class="header-caption">Total DigiDots</div>
                    </div>
                    <!-- <div class="header-caption">total term points</div> -->

                    <a title="{{ fullname ? fullname : 'admin digimaker' }}"
                        class="nav-link text-end border navbar-dropdown profile-chip" href="javascript:void(0)"
                        style="max-width: 15em; min-width: 5em;">
                        <!-- <ion-icon name="person-circle-outline"></ion-icon> -->
                        <div class="profile">
                            <p class="user-name word-wrap">
                                {{ fullname ? fullname : 'admin digimaker' }}
                                <!-- {{ fullname ? shortName : 'admin digimaker' }} -->
                            </p>
                        </div>
                    </a>
                    <button class="logout d-flex flex-column align-items-center" (click)="onLogout()">
                        <div class="logoff-btn">
                            <i class="fa fa-power-off" size="large" aria-hidden="true"></i>
                        </div>
                    </button>
                </div>
            </div>
        </nav>
    </ion-toolbar>
</ion-header>